import React, { useState } from 'react';
import { Container, Row, Col, Button, ListGroup, Card, Badge } from 'react-bootstrap';
import { Minus, Plus, Eye, Edit3 } from 'lucide-react';
import { useLocation } from "react-router-dom";
const RecipeInstructions = () => {


  const [servings, setServings] = useState(2);
  

  const ingredients = [
    { name: "d'huile d'olive", amount: "½ cs" },
    { name: "oignon haché menu", amount: "½" },
    { name: "gousse d'ail hachée menu", amount: "½" },
    { name: "piment rouge épépiné et coupé en fines lamelles", amount: "¼" },
    { name: "céleri-rave (env. 200 g) coupé en dés", amount: "¼" },
    { name: "de champignons de Paris émincés", amount: "125 g" },
    { name: "de tomates concassées (env. 400 g)", amount: "½ boîte" },
    { name: "de lentilles brunes (Beluga)", amount: "40 g" },
    { name: "d'origan ciselé", amount: "1 cs" },
    { name: "d'eau", amount: "1 ¼ dl" },
    { name: "de sel", amount: "½ de cc" },
    { name: "de poivre", amount: "un peu" },
  ];

  const instructions = [
    {
      title: "Ragoût de lentilles",
      steps: [
        "Faire chauffer l'huile dans une poêle. Faire revenir l'oignon, l'ail et le piment pendant env. 3 min.",
        "Ajouter le céleri et les champignons, poursuivre la cuisson pendant env. 10 min. Ajouter les tomates, les lentilles et l'origan, verser l'eau. Porter à ébullition puis baisser le feu et laisser mijoter à couvert env. 10 min. Terminer la cuisson à découvert pendant env. 10 min. puis assaisonner."
      ]
    },
  /*   {
      title: "Aubergines",
      steps: [
        "Faire chauffer l'huile dans une poêle et y faire cuire les rondelles d'aubergine de chaque côté pendant env. 5 min., saler et réserver."
      ]
    },
    {
      title: "Purée de pommes de terre",
      steps: [
        "Préparer la purée de pommes de terre selon les indications figurant sur l'emballage, ajouter le beurre, assaisonner et laisser refroidir."
      ]
    },
    {
      title: "Gratinage",
      steps: [
        "Verser le ragoût de lentilles dans le moule, poser les aubergines par-dessus. Verser la purée de pommes de terre sur les aubergines et lisser. Parsemer de Sbrinz.",
        "Faire gratiner env. 15 min. dans le haut du four préchauffé à 220 °C."
      ]
    } */
  ];


  const location = useLocation();
  const recipe = location.state?.recipe;
console.log('recipe in detail', recipe)
  if (!recipe) {
    return <p>Aucune recette trouvée.</p>;
  }



  return (
    
    <Row className="d-flex justify-content-center gap-3 mb-4">
      {/* Colonne des ingrédients */}
      <Col xs={12} sm={12} md={5} lg={5}>
      
        
        <Card className="shadow-sm rounded p-3 border-0">
            <h2 className="text-warning fw-bold text-center mb-3">📋 Liste des Ingrédients</h2>
          <ListGroup variant="flush">
            {recipe.ingredients.map((ingredient, index) => (
              <ListGroup.Item key={index} className="py-3">
                <div>
                  
                  <h5 className="fw-bold text-success mb-2">{ingredient.food?.name || "N/A"}</h5>
                  <p className="mb-1"><strong>Catégorie:</strong> {ingredient.food?.category || "N/A"}</p>
                  <p className="mb-1"><strong>Quantité:</strong> {ingredient.quantity || "N/A"}</p>
                 
                  <p className="text-muted"><strong>Description:</strong> {recipe.description || "No description available"}</p>
  
                  {/* Valeurs nutritionnelles */}
                  <div className="mt-2">
                    <strong>Valeurs nutritionnelles :</strong>
                    <div className="d-flex gap-2 flex-wrap mt-2">
                      <Badge bg="info" className="fw-bold fs-14">🔥 {ingredient.food?.nutritionalValue?.calories || 0} kcal</Badge>
                      <Badge bg="success"  className="fw-bold fs-14">💪 {ingredient.food?.nutritionalValue?.protein || 0}g Protéines</Badge>
                      <Badge bg="warning"  className="fw-bold fs-14">🍞 {ingredient.food?.nutritionalValue?.carbs || 0}g Glucides</Badge>
                      <Badge bg="danger"  className="fw-bold fs-14">🥑 {ingredient.food?.nutritionalValue?.fats || 0}g Graisses</Badge>
                    </div>
                  </div>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      </Col>
  
      {/* Colonne des instructions */}
      <Col xs={12} sm={12} md={4} lg={4}>
        
  
        {/* Section Instructions */}
        <Card >
          <Card.Body className="p-4">

                    <h2 className="text-warning fw-bold text-center mb-3">🍽️ Voici comment faire</h2>
            
          
            <Card.Title className="fw-bold  text-success text-center mb-3">{recipe.name}</Card.Title>
            
            <h5 className="fw-bold mb-2 text-secondary">📖 Instructions</h5>
            <p className="text-muted" >{recipe.instructions}</p>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  
  
  );
};

export default RecipeInstructions;